var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recent-month-charge-power"},[_c('pub-info-title',{attrs:{"title":'近1月充电量与充电次数趋势',"isModal":true}}),_c('div',{ref:"Line",staticClass:"power-line-chart"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }